import { fcApis } from '@apis/fcApis';
import { useQuery } from '@hooks/useQuery';
import { FormError, NotFoundError } from '@utils/errors';
import { isValidJapaneseZipcode } from '@utils/sanitize';

export const usePrefAndCityByZipcode = ({ zipcode }: { zipcode?: string }) => {
  return useQuery(
    [`/fc/pref-and-city-by-zipcode/?zipcode=${zipcode}`],
    async () => {
      const r = await fcApis.get('/fc/pref-and-city-by-zipcode/', {
        query: { zipcode: zipcode! },
      });

      if (r[200]) return r[200];

      if (r[404]) throw new NotFoundError(r[404].message);

      if (r[404]) throw new FormError('PrefAndCityByZipcode', r[400]!);

      throw new FormError('PrefAndCityByZipcode', {});
    },
    {
      enabled: !!zipcode && isValidJapaneseZipcode(zipcode),
      staleTime: Infinity,
    },
  );
};
